import React from "react"
import { Tooltip } from '@mui/material'

export default function CastumTooltip({title, tooltipClass = '', children, ...props }) {

  return (
      <Tooltip title={title} classes={{tooltip: tooltipClass}} {...props}>
          {children}
      </Tooltip>
  )
}